import { Grid } from "@mui/material";
import React, { useEffect, useRef } from "react";
import FormControl from "@mui/material/FormControl";
import FormLabels from "../../../../library/custom/formLabel/FormLabels";
import { useState } from "react";
import SearchAutoComplete from "../../../../library/custom/searchAutoComplete/SearchAutoComplete";
import {
  API_STATUS,
  HBNEXT_ORG_ID,
  ORG_ID,
  PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
  USER_ID,
  USER_TYPE,
} from "../../../../constant/constant";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import { TableLoader } from "../../../../library/common/Loader";
import NORow from "../../../../library/custom/noRow/noRow";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import "./primaryInspectorList.scss";
import Buttons from "../../../../library/custom/button/Button";
import BackBtn from "../../../../library/custom/backBtn/backBtn";
import UserFilterList from "../../../admin/shared/UserFilterList ";
import { WEEKDAYS } from "../../../../constant/storm-water/constant";
import { useNavigate } from "react-router-dom";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import { InactiveClient } from "../../../../utils/helper";
import { useDebounce } from "../../../../utils/useDebounceSearch";

function PrimaryInspectorList({
  allUsers,
  onSearch,
  isLoading,
  dataBack,
  InspectorListData,
  SwInspectorList,
  getSwReference,
  assignSwInspectorDatas,
  setupData,
  assignsSwInspectorData,
  assignSwInspectorDataStatus,
  setIsSuccess,
  setOrgID,
}) {
  const history = useNavigate();
  console.log("deploy");

  const [users, setUsers] = useState("");
  const [primaryInspector, setPrimaryInspector] = useState("");
  const [primaryInspectorError, setPrimaryInspectorError] = useState(false);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [assignBox, setAssignBox] = useState(false);
  const [inspectionDay, setInspectionDay] = useState("");
  const [frequency, setFrequency] = useState("");
  const [setupIds, setSetupIds] = useState([]);
  const [errorMsgPrimaryInspectors, setErrorMsgPrimaryInspectors] =
    useState(false);
  const [errorMsgPrimaryInspectorsMSG, setErrorMsgPrimaryInspectorsMSG] =
    useState();
  const autoCompGroup = useRef(null);
  const debouncedSearch = useDebounce(search, 500);

  useEffect(() => {
    if (
      assignSwInspectorDataStatus === API_STATUS.SUCCESS &&
      assignsSwInspectorData?.isLoading === false &&
      assignsSwInspectorData?.data?.result === ""
    ) {
      setIsSuccess(false);
      setPrimaryInspectorValue("");
    }
  }, [assignsSwInspectorData]);

  const inspectionDayOnChanges = (e) => {
    setInspectionDay(e.target.value);
  };

  const frequencyTypeOnchange = (e) => {
    setFrequency(e.target.value);
  };

  const addAssignBox = () => {
    if (InactiveClient()) return;
    setAssignBox(!assignBox);
  };
  const [usersValue, setUsersValue] = useState();

  const onChangeUsers = (value) => {
    setUsers(value?.key || "");
    setUsersValue({ key: value?.key ?? "", value: value?.value ?? "" });
    setAccessUserId([]);
    setSetupIds([]);

    const data = {
      page: 1,
      pageSize: pageSize,
      search: "",
      UserId: value?.key || "",
      InspectionDayId: "",
      FrequencyId: "",
    };
    SwInspectorList(data);
  };

  const credcloumns = [
    { field: "projectNo", headerName: "Project Number", flex: 2.5 },
    { field: "siteName", headerName: "Site Name", flex: 2.5 },
    { field: "projectName", headerName: "Project ", flex: 2 },
    {
      field: "orgName",
      headerName: "Client ",
      flex: 2,
      hide: parseInt(ORG_ID()) !== HBNEXT_ORG_ID,
    },
    {
      field: "inspectionDay",
      headerName: "Inspection Day",
      flex: 3,
      renderCell: (rows) => {
        return rows?.row?.inspectionDay === 0
          ? "Sunday"
          : rows?.row?.inspectionDay === 1
            ? "Monday"
            : rows?.row?.inspectionDay === 2
              ? "Tuesday"
              : rows?.row?.inspectionDay === 3
                ? "Wednesday"
                : rows?.row?.inspectionDay === 4
                  ? "Thursday"
                  : rows?.row?.inspectionDay === 5
                    ? "Friday"
                    : rows?.row?.inspectionDay === 6
                      ? "Saturday"
                      : "";
      },
    },
    { field: "frequency", headerName: "Frequency", flex: 2.5 },
    {
      field: "primaryInspectorName",
      headerName: "Primary Inspector",
      flex: 3.5,
    },
    {
      field: "icon",
      renderHeader: () => (
        <SettingTable
          noOfRecords={InspectorListData?.data?.count ?? 0}
          numberOfItemsPerPage={PAGE_SIZE}
          incidentLists={InspectorListData?.data?.inspectionSetupList ?? []}
          fileNameXL={"InspectionAuthorityList"}
        />
      ),
      flex: 2,
      sortable: false,
      disableClickEventBubbling: true,
    },
  ];
  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    const data = {
      page: page,
      pageSize: newPazeSize,
      search: search ? search : "",
      UserId: users ? users : "",
      InspectionDayId:
        inspectionDay === 7 ? 0 : inspectionDay === "" ? "" : inspectionDay,
      FrequencyId: frequency ? frequency : "",
    };
    SwInspectorList(data);
  };
  const handlePagignation = (newPage) => {
    setPage(newPage);
    const data = {
      page: newPage + 1,
      pageSize: pageSize,
      search: search ? search : "",
      UserId: users ? users : "",
      InspectionDayId:
        inspectionDay === 7 ? 0 : inspectionDay === "" ? "" : inspectionDay,
      FrequencyId: frequency ? frequency : "",
    };
    SwInspectorList(data);
  };

  const handleautoSearch = (event) => {
    let searchText = "";
    if (event.target.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const handleApply = (state) => {
    setAnchorEl(null);
    const data = {
      page: 1,
      pageSize: pageSize,
      search: search ? search : "",
      UserId: users ? users : "",
      InspectionDayId:
        inspectionDay === 7 ? 0 : inspectionDay === "" ? "" : inspectionDay,
      FrequencyId: frequency ? frequency : "",
    };
    SwInspectorList(data);
  };

  const handleSearch = (data) => {
    setAnchorEl(null);
    SwInspectorList(data);
  };

  const handleClear = () => {
    setSearch("");
    setInspectionDay("");
    setFrequency("");
    setPage(0);
    setPageSize(PAGE_SIZE);
    const data = {
      page: 1,
      pageSize: PAGE_SIZE,
      search: "",
      UserId: "",
      InspectionDayId: "",
      FrequencyId: "",
    };
    handleSearch(data);
  };
  const [primaryInspectorValue, setPrimaryInspectorValue] = useState();
  const onChangePrimaryInspector = (value) => {
    setPrimaryInspector(value?.key);
    setErrorMsgPrimaryInspectors(false);
    setPrimaryInspectorValue({
      key: value?.key ?? "",
      value: value?.value ?? "",
    });
  };

  const [accessUserId, setAccessUserId] = useState([]);
  const [results, setResults] = useState([]);

  const onRowClick = (rows) => {
    setResults(rows?.row?.primaryInspectorId);
    setOrgID(rows?.row?.orgId);
  };

  const assignInspector = () => {
    let isFieldEmpty = false;
    if (primaryInspector == results) {
      setErrorMsgPrimaryInspectors(true);
      setErrorMsgPrimaryInspectorsMSG("Choose New Primary Inspector");
      isFieldEmpty = true;
    } else {
      setErrorMsgPrimaryInspectors(false);
      setErrorMsgPrimaryInspectorsMSG(false);
    }
    if (!primaryInspector) {
      setPrimaryInspectorError(true);
      isFieldEmpty = true;
    }
    if (!isFieldEmpty) {
      const assignData = {
        setupId: setupIds,
        isPrimary: true,
        inspectorId: parseInt(primaryInspector),
        userId: parseInt(USER_ID()),
      };
      assignSwInspectorDatas(assignData);
    }
  };

  useEffect(() => {
    if (isLoading === false && setupData) {
      setAccessUserId([setupData?.mapId]);
      setSetupIds([setupData?.mapId]);
      setResults(setupData?.secondaryInspectors);
      const setupRow = InspectorListData?.data?.inspectionSetupList?.find(
        (item) => item.setupId === setupData?.mapId,
      );
      if (setupRow?.orgId !== undefined) {
        setOrgID(setupRow.orgId);
      }
    }
  }, [setupData, isLoading]);

  useEffect(() => {
    const data = {
      page: page,
      pageSize: pageSize,
      search: debouncedSearch,
      UserId: users ? users : "",
      InspectionDayId:
        inspectionDay === 7 ? 0 : inspectionDay === "" ? "" : inspectionDay,
      FrequencyId: frequency ? frequency : "",
    };
    SwInspectorList(data);
  }, [debouncedSearch]);

  return (
    <div>
      <Grid item container mt={1} spacing={2}>
        <Grid item lg={4} xs={12} sm={12} md={4}>
          <FormControl fullWidth>
            <FormLabels label={"Primary Inspector Name"} isRequired={false} />
            <SearchAutoComplete
              name="selectInspector"
              optionsData={allUsers ?? []}
              typeOnchange={(event, value) =>
                onSearch(event.target.value, USER_TYPE.EMPLOYEE)
              }
              isKeyValuePair={true}
              value={usersValue ? usersValue : ""}
              onChange={(event, value) => onChangeUsers(value)}
              isLoading={isLoading}
              noOptionsTextMsg={"No User"}
              autoCompClear={autoCompGroup}
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid item container mt={1} spacing={2}>
        <Grid item lg={12} xs={12} sm={12} md={4}>
          <section className="grid_main_sec">
            <div className="grid_main_body">
              <div className="filter_of_caselist">
                <div className="searchcaseid">
                  <label htmlFor="search">
                    <span>
                      <SearchIcon />
                    </span>
                    <div>
                      <input
                        id="search"
                        placeholder="Search"
                        type="text"
                        value={search}
                        className=""
                        onChange={handleautoSearch}
                        autoComplete="off"
                      />
                    </div>
                  </label>
                </div>

                <div className="filter_btn">
                  <button
                    aria-describedby={id}
                    variant="contained"
                    type="button"
                    name="btn"
                    onClick={(e) => handleClick(e)}
                  >
                    <FilterListIcon id="icn" /> Filters
                  </button>
                  <UserFilterList
                    firstLabel="Inspection Day"
                    secondLabel="Frequency"
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    handleClose={handleClose}
                    handleApply={handleApply}
                    handleClear={handleClear}
                    firstLebelFilter={WEEKDAYS}
                    secondLebelFilter={getSwReference?.insfrequencyList ?? []}
                    firstLebelOnChanges={inspectionDayOnChanges}
                    secondLebelOnChanges={frequencyTypeOnchange}
                    firstLebelValue={inspectionDay}
                    secondLebelValue={frequency}
                    resetBtn={true}
                    isShow={parseInt(frequency) === 2}
                  />
                </div>
              </div>

              <div className="desc_box row_uniq">
                <div className="table_style_ui">
                  <GridTable
                    getRowId={(r) => r.setupId}
                    rows={InspectorListData?.data?.inspectionSetupList ?? []}
                    rowCount={InspectorListData?.data?.count ?? 0}
                    columns={credcloumns}
                    loading={isLoading}
                    checkboxSelection={true}
                    page={page}
                    pagination
                    pageSize={pageSize}
                    rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                    onPageChange={handlePagignation}
                    onPageSizeChange={handlePageSizeChange}
                    backIconButtonProps={{ disabled: false }}
                    onClick={(rows) => onRowClick(rows)}
                    selectionModel={accessUserId}
                    hideFooterSelectedRowCount
                    onSelectionModelChange={(selection) => {
                      const allRows =
                        InspectorListData?.data?.inspectionSetupList ?? [];

                      if (selection.length === 0) {
                        setAccessUserId(selection);
                        setSetupIds([]);
                        setOrgID("");
                        // Clear inspector field when selection is cleared
                        setPrimaryInspectorValue("");
                        setPrimaryInspector("");
                        setPrimaryInspectorError(false);
                        setErrorMsgPrimaryInspectors(false);
                        setErrorMsgPrimaryInspectorsMSG("");
                        return;
                      }

                      const selectedRows =
                        allRows?.filter((item) =>
                          selection.includes(item.setupId),
                        ) || [];
                      const selectedSetupIds =
                        selectedRows.map((item) => item.setupId) || [];
                      const uniqueOrgIds = Array.from(
                        new Set(
                          selectedRows
                            .map((item) => item.orgId)
                            .filter(
                              (orgId) => orgId !== undefined && orgId !== null,
                            ),
                        ),
                      );
                      let orgIdForSearch = "";
                      if (uniqueOrgIds.length === 1) {
                        orgIdForSearch = uniqueOrgIds[0];
                      } else if (uniqueOrgIds.length > 1) {
                        orgIdForSearch = 0;
                      }
                      const previousSetupIds = setupIds;
                      const setupIdsChanged =
                        previousSetupIds.length !== selectedSetupIds.length ||
                        !previousSetupIds.every((id) =>
                          selectedSetupIds.includes(id),
                        );

                      if (setupIdsChanged) {
                        setPrimaryInspectorValue("");
                        setPrimaryInspector("");
                        setPrimaryInspectorError(false);
                        setErrorMsgPrimaryInspectors(false);
                        setErrorMsgPrimaryInspectorsMSG("");
                      }
                      setAccessUserId(selection);
                      setSetupIds(selectedSetupIds);
                      setOrgID(orgIdForSearch);
                    }}
                    isRowSelectable={(params) => {
                      return true;
                    }}
                    multipleSelection={true}
                    disableSelectionOnClick
                    components={{
                      LoadingOverlay: TableLoader,
                      NoRowsOverlay: NORow,
                    }}
                  />
                </div>
              </div>
            </div>
          </section>
        </Grid>
      </Grid>
      {setupIds.length > 0 && checkPrivileges([12, 96, 97]) && (
        <Grid container>
          <Grid item md={12} xs={12} mt={4}>
            <div className="addAssignInspector" onClick={() => addAssignBox()}>
              {assignBox ? (
                <>
                  <RemoveIcon className="addIconBtns" /> Assign Inspector
                </>
              ) : (
                <>
                  <AddIcon className="addIconBtns" /> Assign Inspector
                </>
              )}
            </div>
          </Grid>
        </Grid>
      )}

      {assignBox && (
        <>
          <Grid item container mt={3} spacing={2}>
            <Grid item lg={4} xs={12} sm={12} md={4}>
              <FormLabels label="Add Primary Inspectors" isRequired={true} />
              <SearchAutoComplete
                name="selectUser"
                optionsData={allUsers ?? []}
                typeOnchange={(event, value) =>
                  onSearch(event.target.value, USER_TYPE.EMPLOYEE)
                }
                isKeyValuePair={true}
                value={primaryInspectorValue}
                onChange={(event, value) => onChangePrimaryInspector(value)}
                isLoading={isLoading}
              />
              {primaryInspectorError && !primaryInspector && (
                <div className="errorMsg">Please enter this required field</div>
              )}
              {errorMsgPrimaryInspectors && (
                <div className="error">{errorMsgPrimaryInspectorsMSG}</div>
              )}
            </Grid>
          </Grid>
          <Grid container mt={3} spacing={1}>
            <Grid lg={2} xs={12} sm={4} md={4} mt={1.5}>
              <Buttons
                varientText={true}
                label="Cancel"
                onClick={() => history(-1)}
              />
            </Grid>
            <Grid lg={1.5} xs={6} sm={4} md={4} mt={1.5}>
              <Buttons
                varientContained={true}
                label={"Assign"}
                onClick={() => assignInspector()}
              />
            </Grid>

            <Grid item lg={4} xs={12} sm={12} md={4}></Grid>
          </Grid>
        </>
      )}
      <Grid container mt={3} spacing={1} alignItems={"left"}>
        <Grid lg={2} xs={12} sm={4} md={4}>
          <div className="insBackBtn">
            <BackBtn dataBack={dataBack} />
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default PrimaryInspectorList;
